import {useCallback, useEffect} from "react";
import {setIsLoading} from "../../payroll/slices/payrollSlice";
import {generateRandomString} from "../../../utils/helper";
// import * as incomeSerices from "../../payroll/services/incomeDeductionApi";
import alert from "../../../components/elements/Alert";
import {WELFARE_CALCULATE_TYPE} from "../../payroll/schemas/welfareSchema";
import * as templateServices from "../services/notificationTemplateApi"


import {useDispatch, useSelector} from "react-redux";
import {useState} from "react";

function useWelfare() {
    const dispatch = useDispatch();
    const currentCompany = useSelector((state) => state.company.currentCompany);
    const currentApprover = useSelector((state) => state.company.currentEmployee);
    const currentEmployee = useSelector((state) => state.company.currentEmployee);
    const [incomeOptions, setIncomeOptions] = useState([]);

const getIncomeDeductionOptions = useCallback(
    async (type) => {
        try {
            dispatch(setIsLoading(true));
            const values = {
                requestId: generateRandomString(),
                companyId: currentCompany,
                employeeId: currentApprover,
                actionId: currentEmployee,
            };
            const response = await templateServices.getDropdownTemplateById(values);
            setIncomeOptions(response.data);
        } catch (error) {
            alert({ type: "error", resultObject: error });
        } finally {
            dispatch(setIsLoading(false));
        }
    },
    [currentCompany, dispatch]
);

const onCalculateAsChange = useCallback(
    (type) => {
        getIncomeDeductionOptions(type);
    },
    [getIncomeDeductionOptions]
);

useEffect(() => {
    if (typeof currentCompany !== "object") {
        getIncomeDeductionOptions(WELFARE_CALCULATE_TYPE.INCOME);
    }
}, [currentCompany, getIncomeDeductionOptions]);



return {
    onCalculateAsChange,
    incomeOptions
};

}


export default useWelfare;